var PAGE_SETTINGS_STYLE_IDS = ['lay-page-settings-menu-colors', 'lay-page-settings-phone-menu-colors', 'lay-page-settings-overlay-burger-color', 'lay-page-settings-phone-overlay-burger-color', 'lay-page-settings-phone-mobile-menu-burger-color']
var overlayBasePageSettingsSnapshot = null
var PAGE_SETTINGS_DEBUG = false
var debugPrefix = '[page-settings-overlay-debug]'

var debugLog = function () {
	if (!PAGE_SETTINGS_DEBUG) return
	try {
		var args = Array.prototype.slice.call(arguments)
		args.unshift(debugPrefix)
		console.log.apply(console, args)
	} catch (e) {}
}

var getCurrentBodyIdValue = function () {
	if (!document.body) {
		return null
	}
	var dataId = document.body.getAttribute('data-id')
	if (dataId != null && dataId !== '') {
		return String(dataId)
	}
	var match = (document.body.className || '').match(/\bid-(\d+)\b/)
	return match ? match[1] : null
}

var getCurrentStylesSnapshot = function () {
	var snapshot = {}
	for (var i = 0; i < PAGE_SETTINGS_STYLE_IDS.length; i++) {
		var id = PAGE_SETTINGS_STYLE_IDS[i]
		var el = document.getElementById(id)
		snapshot[id] = el ? el.textContent || '' : ''
	}
	return snapshot
}

var applyStyles = function (stylesObj) {
	if (!stylesObj || typeof stylesObj !== 'object') {
		debugLog('apply skipped: invalid styles object', stylesObj)
		return
	}
	var styleLengths = {}
	for (var i = 0; i < PAGE_SETTINGS_STYLE_IDS.length; i++) {
		var id = PAGE_SETTINGS_STYLE_IDS[i]
		var css = stylesObj[id] || ''
		styleLengths[id] = css.length
		var el = document.getElementById(id)
		if (!el) {
			el = document.createElement('style')
			el.id = id
			document.head.appendChild(el)
		}
		el.textContent = css
	}
	debugLog('applied styles', {
		currentBodyId: getCurrentBodyIdValue(),
		styleLengths: styleLengths,
	})
}

var captureSnapshotBeforeOverlayFetch = function (params) {
	var isProjectOverlay = params && params.isProjectOverlay
	var shouldOpenOverlay = params && params.shouldOpenOverlay
	var type = params && params.type
	var id = params && params.id
	var explicitBasePageId = params && params.basePageId
	if (isProjectOverlay !== 'true' || shouldOpenOverlay !== true || overlayBasePageSettingsSnapshot) {
		return
	}
	overlayBasePageSettingsSnapshot = {
		bodyId: explicitBasePageId != null && explicitBasePageId !== '' ? String(explicitBasePageId) : getCurrentBodyIdValue(),
		styles: getCurrentStylesSnapshot(),
	}
	var snapshotLengths = {}
	for (var s = 0; s < PAGE_SETTINGS_STYLE_IDS.length; s++) {
		var sid = PAGE_SETTINGS_STYLE_IDS[s]
		snapshotLengths[sid] = (overlayBasePageSettingsSnapshot.styles[sid] || '').length
	}
	debugLog('snapshot captured before overlay fetch', {
		bodyId: overlayBasePageSettingsSnapshot.bodyId,
		basePageIdFromOverviewState: explicitBasePageId,
		styleLengths: snapshotLengths,
		type: type,
		id: id,
		cachePathPossible: true,
	})
}

var restoreAfterOverlayDestroy = function () {
	if (!overlayBasePageSettingsSnapshot) {
		debugLog('restore skipped: no snapshot')
		return
	}
	var currentBodyId = getCurrentBodyIdValue()
	debugLog('restore check', {
		currentBodyId: currentBodyId,
		snapshotBodyId: overlayBasePageSettingsSnapshot.bodyId,
	})
	if (currentBodyId !== null && currentBodyId === overlayBasePageSettingsSnapshot.bodyId) {
		debugLog('restore applying snapshot styles')
		applyStyles(overlayBasePageSettingsSnapshot.styles)
	} else {
		debugLog('restore skipped: body id mismatch')
	}
	overlayBasePageSettingsSnapshot = null
}

var i = function () {
	window.laytheme.on('destroyoverlay', restoreAfterOverlayDestroy)
}

var page_settings_styles_restore = {
	i: function () {
		i()
	},
	captureSnapshotBeforeOverlayFetch: function (params) {
		captureSnapshotBeforeOverlayFetch(params)
	},
	applyStyles: function (stylesObj) {
		applyStyles(stylesObj)
	},
}

export default page_settings_styles_restore
